import { DateUtility } from '@mchs/web-core';
import {
  AppointmentType,
  ProviderDetails,
  SchedulingDetails,
} from '../api/models';
import {
  GetUnauthenticatedProviderAppointmentTypesApiService,
  GetUnauthenticatedProviderAppointmentTypesRequest,
} from '../api/services';
import { SchedulingUpdateContextType } from '../components/context/schedulingContext';

export enum GetAppointmentTypeReturnValue {
  Success,
  Empty,
  Failure,
}

export const getProviderAppointmentTypes = async (
  providerDetails: ProviderDetails
): Promise<AppointmentType[]> => {
  if (providerDetails?.practitionerId) {
    const request: GetUnauthenticatedProviderAppointmentTypesRequest = {
      cernerPractitionerId: providerDetails?.practitionerId,
    };

    const response =
      await GetUnauthenticatedProviderAppointmentTypesApiService.execute(
        request
      );
    if (
      response.succeeded &&
      response.data &&
      response.data.appointmentTypeList &&
      response.data.appointmentTypeList.length > 0
    ) {
      return response.data.appointmentTypeList;
    } else {
      return [];
    }
  } else {
    return [];
  }
};

const filterAppointmentTypeList = (
  appointmentTypeList: AppointmentType[],
  schedulingDetails: SchedulingDetails
): AppointmentType[] => {
  const patDOB =
    schedulingDetails.patientDetails?.demographics?.dateOfBirth !== undefined
      ? new Date(
          Date.parse(
            schedulingDetails.patientDetails?.demographics?.dateOfBirth
          )
        )
      : undefined;

  return appointmentTypeList.filter((apptType) => {
    const afterDate = DateUtility.getDateFromMM_DD_YYYYString(
      apptType.bornAfterDate
    );
    const beforeDate = DateUtility.getDateFromMM_DD_YYYYString(
      apptType.bornBeforeDate
    );
    return (
      (patDOB === undefined || afterDate === undefined || patDOB > afterDate) &&
      (patDOB === undefined || beforeDate === undefined || patDOB < beforeDate)
    );
  });
};

export const updateProviderAppointmentTypes = async (
  schedulingDetails: SchedulingDetails,
  schedulingUpdateContext: SchedulingUpdateContextType
): Promise<GetAppointmentTypeReturnValue> => {
  if (schedulingDetails.providerDetails?.practitionerId) {
    const appointmentTypeList = await getProviderAppointmentTypes(
      schedulingDetails.providerDetails
    );
    const filteredList = filterAppointmentTypeList(
      appointmentTypeList,
      schedulingDetails
    );
    schedulingUpdateContext.changeSchedulingDetails({
      ...schedulingDetails,
      providerDetails: {
        ...schedulingDetails.providerDetails,
        appointmentTypeList: filteredList,
      },
    });
    return filteredList.length === 0
      ? GetAppointmentTypeReturnValue.Empty
      : GetAppointmentTypeReturnValue.Success;
  }
  return GetAppointmentTypeReturnValue.Failure;
};
